// Make Names Sentence Case
export function capitalizeAndLowercaseRest(string) {
  if (typeof string !== 'string' || string.length === 0) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// Calculate Age From DOB Data
export function calculateAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

// Add Timestamp To Footer & Print Registration Form
export function addTimestampToFooter() {
  const now = new Date();
  const formattedDateTime = `Registration confirmed. Printed on: ${now.toLocaleDateString()} at ${now.toLocaleTimeString()}`;
  const timestampElement = document.getElementById("print-timestamp");
  
  if (timestampElement) {
    timestampElement.innerHTML = formattedDateTime;
  }
}

// Format Phone Numbers
export function formatPhoneNumber(phoneNumber) {
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  if (digitsOnly.length === 10) {
    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
  } else {
    return "Invalid phone number length";
  }
}

/**
 * Attaches active input listeners to automatic formatting loops for phone boxes
 */
export function initPhoneFormatters() {
  const phoneInputs = document.querySelectorAll('#parentPhone, #emergPhone');

  phoneInputs.forEach(input => {
    if (!input) return;

    input.addEventListener('input', (event) => {
      // 1. Strip non-digits to analyze raw length calculations
      let rawDigits = event.target.value.replace(/\D/g, '');
      
      // CRITICAL US FILTER: Automatically drop a leading "1" country code if typed
      if (rawDigits.length > 0 && rawDigits[0] === '1') {
        rawDigits = rawDigits.substring(1);
      }

      // Limit to max 10 characters to prevent overflow formatting bugs
      if (rawDigits.length > 10) {
        rawDigits = rawDigits.substring(0, 10);
      }

      // 2. Format on-the-fly dynamically depending on typing depth
      let formatted = '';
      if (rawDigits.length > 0) {
        formatted += rawDigits.substring(0, 3);
      }
      if (rawDigits.length > 3) {
        formatted += '-' + rawDigits.substring(3, 6);
      }
      if (rawDigits.length > 6) {
        formatted += '-' + rawDigits.substring(6, 10);
      }

      // 3. Push the clean text layout back to the UI element screen view
      event.target.value = formatted;
    });
  });
  // console.log('[Support Module] Active country-code filtered phone watchers bound.');
}


// Dynamic input mask for phone fields to ensure clean formatting as they type
export function maskAsPhoneNumber(inputElement) {
  if (!inputElement) return;

  inputElement.addEventListener('input', (e) => {
    let input = e.target.value.replace(/\D/g, ''); // Strip all non-digits

    // FIX: If autofill or manual typing includes a leading '1' country code, strip it off
    if (input.length === 11 && input.startsWith('1')) {
      input = input.substring(1);
    }

    if (input.length > 10) input = input.substring(0, 10); // Enforce standard 10-digit limit

    // Programmatically rebuild the value string sequentially
    if (input.length === 0) {
      e.target.value = '';
    } else if (input.length <= 3) {
      e.target.value = input;
    } else if (input.length <= 6) {
      e.target.value = `${input.slice(0, 3)}-${input.slice(3)}`;
    } else {
      e.target.value = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6)}`;
    }
  });
}